import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {ContractService} from "../../../shared/services/contract.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {Contract} from "../../../shared/interface/contract";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {NgForm} from "@angular/forms";
import {AnalyticsService} from "../../../shared/services/analytics.service";

@Component({
  selector: 'app-report-contracts',
  templateUrl: './report-contracts.component.html',
  styleUrls: ['./report-contracts.component.scss']
})
export class ReportContractsComponent implements OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private analyticsService: AnalyticsService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.parseFilters();

  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      recordId: 'string',
      type: 'int[]',
      gte$concludeDate: 'date',
      lte$concludeDate: 'date',
      company: 'int',
      status: 'int[]',
      contains$number: 'string',
      gte$activeFrom: 'date',
      lte$activeFrom: 'date',
      gte$activeTo: 'date',
      lte$activeTo: 'date',
      terminationTime: 'int',
      terminationType: 'int',
      period: 'int',
      owner: 'int',
      partner: 'string',
      ofwca: 'string',
      assetsRegional: 'string',
      verified: 'int',
      signedCurrentApplications: 'int',
    }, filters);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: 10,
      ...this.filtersForm.value,
    })]);
  }

  downloadReport(): void {
    this.analyticsService.downloadReportContracts(this.initialFilters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: 10,
    }]);
  }
}
